import { types } from "../../../types";

const initialState = {
    pagination: {
        data: [],
        per_page: 5,
    },
    listBudgets: [],
    openForm: false,
};

export const budgetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.showBudgets:
            return {
                ...state,
                pagination: action.payload.pagination,
            };
        case types.providersOpenModal:
            return {
                ...state,
                openForm: true,
            };
        case types.providersCloseModal:
            return {
                ...state,
                openForm: false,
            };
        case types.showListBudgets:
            return {
                ...state,
                listBudgets: action.payload.list,
            };
        default:
            return state;
    }
};
